module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_woowahan.f6e38e4ef18600c60222a6dcf6e9dca8.png";